export default {
  'Custom': 'Custom',
  'Original': 'Asli',
  'Resolution': 'Resolusi',
  'Frame rate': 'Frame rate',
  'The higher the frame rate, the smoother the animation': 'Semakin tinggi frame rate, semakin halus animasinya.',
  'Start': 'Mulai',
  'End': 'Akhir',
  'Create GIF': 'Buat GIF',
  'Download GIF': 'Unduh GIF',
  'Create A New One': 'Buat Yang Baru',
  'Remake GIF': 'Buat ulang GIF',
  'HitPaw Video to GIF Online': 'HitPaw Video ke GIF Online',
  'Upload and convert video to GIF without any difficulty': 'Unggah dan konversi video ke GIF tanpa kesulitan',
}